export const deleteFlowWatermark = () => {
  function remover() {
    const element = Array.from(document.querySelectorAll('a')).find(
      el => el.ariaLabel == 'React Flow attribution',
    );

    element?.remove();
    console.clear();
  }

  setTimeout(remover, 0);
  setTimeout(remover, 100);
  setTimeout(remover, 200);
};
